import { Injectable } from '@angular/core';
import { StaffDisplayType } from './api/staff.service';

export interface UserPreferences {
  staffDisplay: StaffDisplayType,
  staffDropdownPhotos: boolean

}

const defaultPreferences: UserPreferences = {
  staffDisplay: "firstAndLast",
  staffDropdownPhotos: false
}

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {

  constructor() { }

  //Future load from somewhere else?  Servier, local storage,
 readonly preferences: UserPreferences = defaultPreferences

  get staffDisplay(): StaffDisplayType {
    return this.preferences.staffDisplay
  }

  get staffDropdownPhotos(): boolean {
    return this.preferences.staffDropdownPhotos
  }

}
